export const PRODUCT_IMAGE_UPLOAD_PT_BR = {
	addImage: "Adicionar imagem",
	removeImage: "Remover imagem carregada",
	formatInfo: "JPG ou PNG",
	ariaLabel: {
		uploadedImage: "Imagem do produto carregada",
	},
};

export type ProductImageUploadTranslations = typeof PRODUCT_IMAGE_UPLOAD_PT_BR;
